// extracted by mini-css-extract-plugin
module.exports = {"componentStyle":"ScrollFade_componentStyle__IRbDH","visible":"ScrollFade_visible__7__XH","fade-in":"ScrollFade_fade-in__adgYa"};